import { render, staticRenderFns } from "./SimDetail.vue?vue&type=template&id=9bd144ee&"
import script from "./SimDetail.vue?vue&type=script&lang=js&"
export * from "./SimDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports